import AdminAddPasein from "../../components/AdminFinanceRekapUserFee/FinanceRekapUserFeeAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
